import { render, staticRenderFns } from "./VueBars.vue?vue&type=template&id=2ce5f82b"
import script from "./VueBars.vue?vue&type=script&lang=js"
export * from "./VueBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports